import React, { useEffect, useState } from 'react';
import { initFirebase, listenToVendorLocation } from '../services/firebase';

export default function FirebaseTest() {
  const [status, setStatus] = useState('Initializing...');
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [routeInfo, setRouteInfo] = useState(null);

  useEffect(() => {
    async function testFirebase() {
      try {
        setStatus('Initializing Firebase...');
        initFirebase();
        setStatus('Firebase initialized, testing connection...');

        // Test with service ID 48 (the one we know has data)
        const unsubscribe = listenToVendorLocation('48', (locationData) => {
          console.log('📍 [TEST] Firebase data received:', locationData);
          if (locationData) {
            setData(locationData);
            setStatus('✅ Firebase connection working! Data received.');
            
            // Check for route planning data
            if (locationData.current_latitude && locationData.current_longitude && 
                locationData.endpoint_latitude && locationData.endpoint_longitude) {
              setRouteInfo({
                current: {
                  lat: locationData.current_latitude,
                  lng: locationData.current_longitude
                },
                endpoint: {
                  lat: locationData.endpoint_latitude,
                  lng: locationData.endpoint_longitude,
                  name: locationData.endpoint_name || 'Destination'
                },
                serviceStatus: locationData.current_service_status,
                endpointType: locationData.endpoint_type
              });
            }
          } else {
            setStatus('⚠️ Firebase connected but no data for service 48');
          }
        });

        // Cleanup after 10 seconds
        setTimeout(() => {
          unsubscribe();
          setStatus('Test completed. Check console for details.');
        }, 10000);

      } catch (err) {
        console.error('📍 [TEST] Firebase test error:', err);
        setError(err.message);
        setStatus('❌ Firebase test failed');
      }
    }

    testFirebase();
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <h2>Firebase Connection Test</h2>
      <div style={{ marginBottom: 20 }}>
        <strong>Status:</strong> {status}
      </div>
      
      {error && (
        <div style={{ color: 'red', marginBottom: 20 }}>
          <strong>Error:</strong> {error}
        </div>
      )}
      
      {data && (
        <div style={{ backgroundColor: '#f0f0f0', padding: 15, borderRadius: 5, marginBottom: 20 }}>
          <h3>Location Data Received:</h3>
          <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
      )}
      
      {routeInfo && (
        <div style={{ backgroundColor: '#e3f2fd', padding: 15, borderRadius: 5, marginBottom: 20, border: '1px solid #2196F3' }}>
          <h3>🚗 Route Planning Data:</h3>
          <div><strong>Current Location:</strong> {routeInfo.current.lat}, {routeInfo.current.lng}</div>
          <div><strong>Endpoint:</strong> {routeInfo.endpoint.name} at {routeInfo.endpoint.lat}, {routeInfo.endpoint.lng}</div>
          <div><strong>Service Status:</strong> {routeInfo.serviceStatus}</div>
          <div><strong>Endpoint Type:</strong> {routeInfo.endpointType}</div>
          <div style={{ marginTop: 10 }}>
            <strong>Route URL:</strong> 
            <a 
              href={`https://www.google.com/maps/dir/${routeInfo.current.lat},${routeInfo.current.lng}/${routeInfo.endpoint.lat},${routeInfo.endpoint.lng}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: 10, color: '#2196F3' }}
            >
              View Route on Google Maps
            </a>
          </div>
        </div>
      )}
      
      <div style={{ marginTop: 20 }}>
        <h3>Test Instructions:</h3>
        <ol>
          <li>Make sure the mobile app is running and tracking location for service 48</li>
          <li>Check the browser console for detailed logs</li>
          <li>If data appears above, Firebase is working correctly</li>
          <li>If route planning data appears, the enhanced features are working</li>
          <li>Click "View Route on Google Maps" to see the planned route</li>
        </ol>
      </div>
    </div>
  );
} 